import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, ViewChild} from '@angular/core';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {IExgEvent} from '../misc/interfaces/IExgEvent';
import {ExgApplicationEventEmitter} from '../misc/classes/ExgApplicationEventEmitter';
import {AnnotationTextComponent} from '../receipt/annotation/annotation-text.component';
import {AnnotationCorrectionComponent} from '../receipt/annotation/annotation-correction.component';
import {ExgDataListComponent, ExgModalService} from 'exc-controls-v2';
import {ExgTabV2Component, ExgTabV2ComponentHeaderElement} from '../misc/exg-tab-v2/exg-tab-v2.component';
import {ExcRestService, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {of} from 'rxjs';
import {ExcSecurityService} from 'exc-security-v2';
import {ApplicationService} from '../services/application.service';
import {EnumerationService} from '../services/enumeration.service';
import {ReceiptStatementDetailsComponent} from './receipt-statement-details/receipt-statement-details.component';
import {UserSettingsService} from '../services/user-settings.service';
import {ExcPdfviewerv3Component} from '../misc/exc-pdf-viewer-v3/exc-pdfviewerv3.component';

@Component({
  selector: 'app-receipt-statement-checkview',
  templateUrl: './receipt-statement-checkview.component.html',
  styles: [
  ]
})
export class ReceiptStatementCheckviewComponent
  extends ExcTranslation
  implements OnInit, IExgTab, IExgEvent {

  [key: string]: any;

  Events = new ExgApplicationEventEmitter();
  /************************/
  @Input()
  Data: { rcptID: string; reloadOpenerView: any } = {
    rcptID: '',
    reloadOpenerView: () => {
    },
  };
  @Input()
  tabinstance: any;
  /************************/
  @ViewChild(ReceiptStatementDetailsComponent) VCreceipt!: ReceiptStatementDetailsComponent;
  @ViewChild('VCTextAnnotation', {read: AnnotationTextComponent})
  VCNote!: AnnotationTextComponent;
  @ViewChild('VCCorrectionAnnotation', {read: AnnotationCorrectionComponent})
  VCCorrection!: AnnotationCorrectionComponent;
  //
  @ViewChild(ExcPdfviewerv3Component) VCPdfViewer!: ExcPdfviewerv3Component;
  @ViewChild('VCreceiptNoteTable', {read: ExgDataListComponent})
  VCreceiptNoteTable!: ExgDataListComponent;
  @ViewChild('VCrightTabControl', {read: ExgTabV2Component})
  VCrightTabControl!: ExgTabV2Component;
  @ViewChild('DivDrawer', {read: ElementRef}) DivDrawer!: ElementRef;

  viewerurl = '';
  /************************/
  init = true;
  checkChanges = true;
  /************************/
  mode = 0; // 0 Inaktiv, 1 Trim, 2 Notes
  rightTabs: ExgTabV2ComponentHeaderElement[] = [];

  workspace = {
    hideViewer: false,
    receiptData: {} as any,
    details: {} as any,
    commentaryDate: [] as any[],
    commentary: [] as any[],
    isLoading: true,
    isLoadingPreview: false,
    annotationData: {} as any,
    loadData: (
      incoming: any,
      company?: any,
      incomingDetails?: any
    ) => {
      if (incoming) {
        this.workspace.receiptData = incoming;
      }
      if (incomingDetails) {
        this.Details = incomingDetails;
        this.workspace.details = incomingDetails;
      }
    },
    loadCommentaries: (Commentary: any, CommentaryDate: any) => {
      this.workspace.commentaryDate = CommentaryDate;
      this.workspace.commentary = Commentary;
    },
    ready: () => {
    },
  };

  /************************/
  get commentary(): any[] {
    return this.workspace.commentary;
  }

  get commentaryDate(): any[] {
    return this.workspace.commentaryDate;
  }

  set Details(value: any) {
    this.details.loadDetails(
      value.caseDetails,
      value.taskDetails,
      value.caseLocation,
      value.caseOEs
    );
  }
  reloadOpenerView = new EventEmitter<any>();

  visibilityController = {
    /******/
    correction: true,
    note: true,
    dev_hidden_pdfviewer: true,
    /******/
    defaultValue: {
      note: true,
      correction: true,
      dev_pdfviewer: false,
    },
    setDefault: () => {
      this.visibilityController.correction =
        this.visibilityController.defaultValue.correction;
      this.visibilityController.note =
        this.visibilityController.defaultValue.note;
      if (this.receiptNoteTable.selectedRow) {
        this.VCNote.initialize();
      }
      if (this.VCreceipt) {
        if (this.VCreceipt.statementEditMode) {
          if (this.VCreceipt.statementChanged) {
            this.showMessageSureAbout();
          } else {
            this.VCreceipt.statementEditMode = false;
            this.VCreceipt.initialize();
          }
        }
      }
    },
    /******/
    noteSwitch: (disabled?: boolean) => {
      if (this.securityHandler.canEdit() && !disabled) {
        this.visibilityController.note = !this.visibilityController.note;
        if (!this.visibilityController.note) {
          if (this.VCreceiptNoteTable.selectedRow >= 0) {
            this.VCNote.note = this.receiptNoteTable.data[this.VCreceiptNoteTable.selectedRow];
          } else {
            this.VCNote.note = {};
          }
          this.VCNote.setDefaultFocus();
        }
        this.VCNote.initialize();
      }
    },
  };
  securityHandler = {
    maxEditableState: 3, // zur Prüfung
    pickedState: 4, // in Prüfung
    finalState: [10, 20],
    canView: (): boolean => {
      return this.securityHandler.noPowerUser();
    },
    canEdit: (): boolean => {
      const actualState =
        this.workspace.receiptData?.rcpt_enmIdent_ReceiptStatus;

      if (!actualState) {
        return false;
      } else {
        if (actualState === 5) {
          return true;
        }

        if (
          !this.securityHandler.finalState.filter((fs) => fs === actualState)
        ) {
          return false; // Final State #Abgeschlossen
        } else if (
          this.securityHandler.noPowerUser() && // SV & Nicht zur Prüfung
          actualState < this.securityHandler.maxEditableState
        ) {
          return true;
        } else if (
          this.securityHandler.powerUser() && // EIS & Nicht zur Prüfung || Prüfung
          (actualState < this.securityHandler.maxEditableState ||
            actualState === this.securityHandler.pickedState)
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    canPick: () => {
      const actualState =
        this.workspace.receiptData?.rcpt_enmIdent_ReceiptStatus;

      return (
        this.securityHandler.powerUser() &&
        actualState === this.securityHandler.maxEditableState
      );
    },
    powerUser: () => {
      return this.excSecurity.isFeatured('STATEMENTCHECK');
    },
    noPowerUser: () => {
      return !this.excSecurity.isFeatured('STATEMENTCHECK') || this.securityHandler.powerUser();
    },
  };

  details = {
    taskDetails: {} as any,
    caseDetails: {} as any,
    caseLocation: {} as any,
    caseOEs: [] as any[],
    loadDetails: (
      caseDate: any,
      taskDate: any,
      locationData: any,
      oeData: any
    ) => {
      this.details.loadCaseDetails(caseDate);
      this.details.loadTaskDetails(taskDate);
      this.details.loadCaseOEs(oeData);
      this.details.loadCaseLocation(locationData);
    },
    loadCaseDetails: (caseData: any) => {
      this.details.caseDetails = caseData;
    },
    loadTaskDetails: (taskData: any) => {
      this.details.taskDetails = taskData;
    },
    loadCaseLocation: (SO: any) => {
      if (SO) {
        this.details.caseLocation = SO;
      } else {
        this.details.caseLocation = {};
      }
    },
    loadCaseOEs: (OEs: any) => {
      if (OEs) {
        this.details.caseOEs = OEs;
      } else {
        this.details.caseOEs = [];
      }
    },
  };
  receiptNoteTable = {
    selectKey: 'rcptAnno_annotationID',
    state: 1,
    selectedRow: undefined as any,
    preSelectedIndex: -1,
    rowChangeByPDFViewer: false,
    deletedByUser: false,
    canChangeSelection: false,
    searchValue: '',
    uiFilter: [],
    uiSort: [],
    data: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 25} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 25,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    selectionChanged: (index: number) => {
      if (this.receiptNoteTable.rowChangeByPDFViewer) {
        this.receiptNoteTable.rowChangeByPDFViewer = false;
      } else if (index !== -1) {
        const Note = this.receiptNoteTable.data[index];
        const annotationId = Note[this.receiptNoteTable.selectKey];

        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
        }

        if (
          this.receiptNoteTable.preSelectedIndex === index &&
          this.VCreceiptNoteTable.selectedRow === index &&
          this.receiptNoteTable.preSelectedIndex !== -1
        ) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              annotationId
            )
          ) {
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.clearSelection();
            this.receiptPDFViewer.focusAnnotation = undefined;
          }
          this.receiptNoteTable.selectedRow = undefined;
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.visibilityController.setDefault();
        } else if (
          ExcCoreModule.Array.ExistsObject(
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
            'annotationId',
            annotationId
          )
        ) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
            annotationId
          );
        } else {
          this.receiptNoteTable.selectedRow = Note;
          this.VCreceiptNoteTable.selectedRow = index;
          this.receiptNoteTable.preSelectedIndex =
            this.VCreceiptNoteTable.selectedRow;
          this.visibilityController.setDefault();
        }
      }
    },
    pageChanged: (page: number) => {
      if (this.receiptNoteTable.MetaInfo.dataPaging !== undefined) {
        this.receiptNoteTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.receiptNoteTable.ready();
    },
    search: (value: string) => {
      this.receiptNoteTable.searchValue = value;
      this.receiptNoteTable.pageChanged(1);
    },
    loadData: (incoming: any[]) => {
      this.receiptNoteTable.data = incoming;
      this.receiptNoteTable.ready();
    },
    ready: () => {
      if (
        !this.receiptNoteTable.data ||
        this.receiptNoteTable.data.length === 0
      ) {
        this.receiptNoteTable.state = 2;
      } else {
        this.receiptNoteTable.state = 0;
      }
    },
    isFiltered: () => {
      return (
        this.receiptNoteTable.MetaInfo.dataFilter
      );
    },
  };
  receiptPDFViewer = {
    focusAnnotation: undefined as any,
    annotationAddMode: {
      // node_modules/@syncfusion/ej2-pdfviewer/src/pdfviewer/base/types.d.ts
      mode: 'None', // AnnotationTyp Zeile 28
      dynamicStampItem: undefined as any, // DynamicStampItem Zeile 148
      signStampItem: undefined as any, // SignStampItem Zeile 159
      standardBusinessStampItem: undefined as any // StandardBusinessStampItem Zeile 169
    },
    annotationAdded: (event: any) => {
      if (this.securityHandler.canEdit()) {
        this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        );

        switch (this.VCrightTabControl.selectedtab) {
          case 1:
            this.receiptNoteTable.rowChangeByPDFViewer = true;
            this.VCreceiptNoteTable.selectedRow = -1;
            this.VCNote.note = {};
            this.VCNote.initialize();
            this.receiptNote();
            break;
        }
        this.saveAnnotatedFile();
      }
    },
    annotationDeleted: (event: any) => {
      if (!this.securityHandler.canEdit()) {
        return;
      }
      this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
        'annotationId',
        event.annotationId
      );
      if (
        ExcCoreModule.Array.ExistsObject(
          this.receiptNoteTable.data,
          this.receiptNoteTable.selectKey,
          event.annotationId
        )
      ) {
        this.receiptNoteTable.rowChangeByPDFViewer = true;
        this.deleteNote(this.receiptNoteTable.rowChangeByPDFViewer);
        this.VCreceiptNoteTable.selectedRow = -1;
        this.receiptNoteTable.preSelectedIndex = -1;
        this.receiptPDFViewer.annotationUnSelectCurrentForm();
      }
    },
    annotationChanged: (event: any) => {
      this.saveChangedAnnotation(event).then();
      this.saveAnnotatedFile();
    },
    annotationSelected: (event: any) => {
      if (!this.securityHandler.canEdit()) {
        return;
      }
      if (event) {
        this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        );
        if (this.VCrightTabControl.selectedtab === 1) {
          if (
            ExcCoreModule.Array.ExistsObject(
              this.receiptNoteTable.data,
              this.receiptNoteTable.selectKey,
              event.annotationId
            )
          ) {
            const index = ExcCoreModule.Array.GetObjectIndex(
              this.receiptNoteTable.data,
              this.receiptNoteTable.selectKey,
              event.annotationId
            );

            this.receiptNoteTable.rowChangeByPDFViewer = true;
            this.VCreceiptNoteTable.selectedRow = index;
            this.receiptNoteTable.selectedRow =
              this.receiptNoteTable.data[index];

            this.receiptNoteTable.preSelectedIndex =
              this.VCreceiptNoteTable.selectedRow;
            this.VCNote.note = this.receiptNoteTable.selectedRow;

            this.VCNote.initialize();
            // console.log('Select-annotation:', index);
          } else {
            this.receiptNoteTable.rowChangeByPDFViewer = true;
            this.VCreceiptNoteTable.selectedRow = -1;
            this.receiptNoteTable.preSelectedIndex = -1;
            this.visibilityController.setDefault();
          }
        }
        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
        }
      }
    },
    annotationUnselected: (event: any) => {
      if (
        ExcCoreModule.Array.ExistsObject(
          this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
          'annotationId',
          event.annotationId
        )
      ) {
        if (
          this.VCrightTabControl.selectedtab === 1 &&
          this.receiptNoteTable.selectedRow
        ) {
          this.receiptNoteTable.rowChangeByPDFViewer = true;
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.visibilityController.setDefault();
        }
        this.receiptPDFViewer.focusAnnotation = undefined;
        this.receiptPDFViewer.annotationUnSelectCurrentForm();
      }
    },
    annotationUnSelectCurrentForm: () => {
      if (
        this.visibilityController.note
      ) {
        if (this.VCNote) {
          this.VCNote.note = {};
          this.VCNote.initialize();
        }
      }
    },
    annotationModeChanged: (event: any): void => {
      this.receiptPDFViewer.annotationAddMode = event;
      console.log('modeChanged[checkview]: ', event);

      if (event.mode === 'None') {
        this.saveAnnotatedFile();
      }
    },
    pageClicked: (): void => {
      if (this.receiptPDFViewer.annotationAddMode.mode === 'HandWrittenSignature') {
        this.VCPdfViewer.viewer.annotation.setAnnotationMode('HandWrittenSignature');
      }
    },
    signatureSelect: ($event: any): void => {
      this.saveAnnotatedFile();
    },
    signatureUnSelect: ($event: any): void => {
      this.saveAnnotatedFile();
    },
    onDocumentLoaded: async () => {
      this.showMessageSomething(
        this.getRessource('MessageViewerReady'),
        'fal fa-check',
        'bg-green'
      );

      // Self repair
      if (this.VCPdfViewer
        && this.VCPdfViewer.VCSyncfusionPdfViewer
        && this.VCPdfViewer.VCSyncfusionPdfViewer.annotation
        && this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule
        && this.VCPdfViewer.VCSyncfusionPdfViewer.viewerBase
      ) {
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.initializeCollection();

        this.VCPdfViewer.VCSyncfusionPdfViewer.viewerBase.deleteAnnotations();
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.clearAnnotationStorage();
        this.VCPdfViewer.VCSyncfusionPdfViewer.deleteAnnotations();

        for (const annotation of JSON.parse(
          this.workspace.receiptData.AggrAnnotation
        )) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.addAnnotation(annotation);
        }

        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.initializeCollection();
        this.saveAnnotatedFile();
      }

      this.VCPdfViewer.enableAnnotationTools(false);

      return of(!this.init).toPromise();
    },
    onViewerReady: async () => {
      this.showMessageSomething(
        this.getRessource('MessageViewerReady'),
        'fal fa-check',
        'bg-green'
      );
      this.chDecRef.markForCheck();
      return of(!this.init).toPromise();
    }
  };
  responseHandler = {
    create(
      result: any,
      rcptAnnotation: any,
      VCPdfViewer: any,
      Data: any
    ): void {
      if (result.success && result.data) {
        Data.loadData(result.data);
        // VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
        //   rcptAnnotation
        // );
        Data.ready();
      }
    },
    edit(result: any, rcptAnnotation: any, VCPdfViewer: any, Data: any): void {
      Data.loadData(result.data);
      VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.selectAnnotation(
        rcptAnnotation
      );
      Data.ready();
    },
    delete(
      result: any,
      annotation: any,
      VCPdfViewer: any,
      Data: any,
      rowChangedByViewer: boolean
    ): void {
      if (result.success && result.data) {
        Data.loadData(result.data);
        if (annotation && !rowChangedByViewer) {
          if (
            ExcCoreModule.Array.ExistsObject(
              VCPdfViewer.annotationCollection,
              'annotationId',
              annotation.annotationId
            )
          ) {
            VCPdfViewer.annotationModule.deleteAnnotationById(
              annotation.annotationId
            );
          }
        }
        Data.ready();
      }
    },
  };

  constructor(
    private chDecRef: ChangeDetectorRef,
    private excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalService: ExgModalService,
    private appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    public userSettingsSvc: UserSettingsService
  ) {
    super();

    setInterval(() => {
      this.chDecRef.detectChanges();
    }, 15);
  }

  ngOnInit(): void {
    this.registerEvents();
    this.initialize();
  }

  registerEvents(): void {
    ExcCoreModule.Services().GlobalRefresh.subscribe(() => {
      if (this.tabinstance.Active) {
        this.loadCheckviewData();
      }
    });
    this.reloadOpenerView.subscribe(() => {
      this.Data?.reloadOpenerView();
    });
    this.Events.Receipt.UploadDialog.Replaced.subscribe(() => {
      this.loadCheckviewData();
      this.workspace.hideViewer = true;
      setTimeout(() => {
        this.workspace.hideViewer = false;
      }, 500);
    });
  }

  initialize(): void {
    const SELF = this;

    this.viewerurl = this.excRest.computeUrl('ReceiptR_BinaryAnnotated', {
      rcptID: this.Data.rcptID,
    });

    SELF.loadCheckviewData(true);
    SELF.rightTabs = [
      {
        get caption(): string {
          return SELF.getGlobal('Details');
        },
        icon_class: SELF.getResource('DetailsIcon'),
        get disabled(): boolean {
          return SELF.workspace.isLoadingPreview;
        },
      },
      {
        get caption(): string {
          return SELF.getGlobal('Notes');
        },
        icon_class: SELF.getResource('subEntities.NotesIcon'),
        get disabled(): boolean {
          return (
            !SELF.securityHandler.canView() || SELF.workspace.isLoadingPreview
          ) || (SELF.workspace.receiptData && !SELF.workspace.receiptData.rcpt_fileStreamID);
        },
      },
    ];
    if (this.tabinstance) {
      this.tabinstance.BeforeClose = () => {
        this.reloadOpenerView.emit();

        if (this.VCPdfViewer?.VCSyncfusionPdfViewer) {
          this.VCPdfViewer.VCSyncfusionPdfViewer.unload();
        }
        return this.showMessageSureAbout(true);
      };
    }
  }

  loadCheckviewData(pickable?: boolean): void {
    const WORKSPACE = this.workspace;
    const SELF = this;
    WORKSPACE.isLoading = true;

    this.excRest
      .get(
        this.excRest.computeUrl('ReceiptR_Checkview', {
          rcptID: this.Data.rcptID,
        })
      )
      .subscribe((response: any) => {
        if (response && response.data) {
          const RESPONSE = response.data;
          SELF.tabinstance.Label = RESPONSE.Receipt.rcptFileName ?? this.getGlobal('ReceiptStatement');
          /****************/
          SELF.receiptNoteTable.loadData(RESPONSE.Notes);
          /****************/
          WORKSPACE.loadData(
            RESPONSE.Receipt,
            RESPONSE.Company,
            {
              caseDetails: RESPONSE.Auftrag,
              taskDetails: RESPONSE.Vorgang,
              caseOEs: RESPONSE.OEs,
              caseLocation: RESPONSE.Location,
            }
          );
          if (pickable && this.securityHandler.canPick()) {
            this.pickReceiptReview();
          }
          if (
            this.VCreceipt
            && this.securityHandler.canEdit()
            && RESPONSE.Receipt.rcpt_enmIdent_ReceiptStatus === 1
          ) {
            this.VCreceipt.switchEditMode(this.securityHandler.canEdit());
          }
          this.workspace.isLoading = false;
          this.chDecRef.markForCheck();
        }
      });
  }

  saveReceipt(cancelToken?: boolean): void {
    if (!cancelToken
      && this.securityHandler.canEdit()
    ) {
      if (!this.workspace.isLoading) {
        if (
          this.VCreceipt.statementChanged ||
          this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus === 1
        ) {
          this.workspace.isLoading = true;

          Object.assign(this.workspace.receiptData, this.VCreceipt.statementClone);

          this.excRest
            .put(
              this.excRest.computeUrl('ReceiptU', {rcptID: this.Data.rcptID}),
              this.workspace.receiptData
            )
            .subscribe((ret: any) => {
              if (ret && ret.success) {
                this.workspace.loadData(ret.data.Receipt);
                this.showMessageSomething(
                  this.getResource('SavedChanges'),
                  'far fa-save',
                  'bg-green'
                );
              }
              this.workspace.isLoading = false;
              this.VCreceipt.switchEditMode(this.securityHandler.canEdit());
              this.VCreceipt.initialize();
            });
        }
      }
    } else {
      this.VCreceipt.initialize();
      this.VCreceipt.switchEditMode(this.securityHandler.canEdit());
      this.modalService.showToast(
        this.getResource('Canceled'),
        'md-toast',
        'far fa-window-close'
      );
    }
  }

  rightTabs_tabChange(event: number): void {
    this.visibilityController.setDefault();
    this.VCPdfViewer.VCSyncfusionPdfViewer.annotationModule.clearSelection();
    this.receiptPDFViewer.focusAnnotation = undefined;

    if (this.VCreceiptNoteTable.selectedRow >= -1) {
      this.VCreceiptNoteTable.selectedRow = -1;
    }

    switch (event) {
      case 0:
        this.VCPdfViewer.enableAnnotationTools(false);
        this.loadCheckviewData(this.securityHandler.canPick());
        break;
      case 1:
        this.VCPdfViewer.enableAnnotationTools(this.securityHandler.canEdit());
        this.receiptNoteTable.ready();
        break;
      default:
        break;
    }
  }

  saveAnnotatedFile(): void {
    if (this.workspace.receiptData && !this.workspace.receiptData.rcpt_fileStreamID) {
      return;
    }

    if (this.VCPdfViewer) {
      this.VCPdfViewer.getFile()
        .then((formData) => {
          formData.set(
            'DataObject',
            JSON.stringify({
              rcptUPT: this.workspace.receiptData.rcptUPT,
              rcpt_filestreamIDAnnotated:
              this.workspace.receiptData?.rcpt_filestreamIDAnnotated,
            })
          );
          return formData;
        })
        .then((fData) => {
          this.excRest
            .post(
              this.excRest.computeUrl('ReceiptCU_FileAnnotated', {
                rcptID: this.Data.rcptID,
              }),
              fData
            )
            .subscribe((ret: any) => {
            });
        });
    }
  }

  async saveChangedAnnotation(event: any): Promise<void> {
    // console.log('save: ', ExcCoreModule.Array.GetObject(
    //   this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
    //   'annotationId',
    //   event.annotationId
    // ));
    if (this.VCPdfViewer
      && this.securityHandler.canEdit()
      && ExcCoreModule.Array.GetObject(
        this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
        'annotationId',
        event.annotationId
      )
    ) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptAnnotationU', {
            rcptID: this.Data.rcptID, annotationID: event.annotationId,
          }),
          {
            rcptAnnoAnnotation: JSON.stringify(ExcCoreModule.Array.GetObject(
              this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
              'annotationId',
              event.annotationId
            ))
          }
        )
        .subscribe((ret: any) => {
        });
    }
  }

  deleteReceiptFile = (): void => {
    if (
      this.securityHandler.canEdit()
      && this.workspace.receiptData.rcpt_fileStreamID
    ) {
      this.modalService
        .showSimple(
          this.getRessource('DeleteFile.Title'),
          this.getRessource('DeleteFile.Text'),
          true,
          true,
          this.getRessource('DeleteFile.Delete'),
          this.getGlobal('Cancel')
        )
        .subscribe((ret: boolean) => {
          if (ret) {
            this.excRest.delete(
              this.excRest.computeUrl('ReceiptD_File', {
                rcptID: this.workspace.receiptData.rcptID
              }), {}
            ).subscribe((rtVal: any) => {
              if (rtVal && rtVal.success) {
                this.showMessageSomething(
                  'Datei entfernt',
                  'fal fa-file-minus',
                  'md-toast bg-green'
                );
                this.loadCheckviewData();
                this.workspace.hideViewer = true;
                setTimeout(() => {
                  this.workspace.hideViewer = false;
                }, 500);
              }
            });
          }
        });
    }
  }

  editFocusAnnotation(textValue: string): any {
    if (
      this.receiptPDFViewer.focusAnnotation &&
      this.receiptPDFViewer.focusAnnotation.subject === 'Text Box'
    ) {
      this.receiptPDFViewer.focusAnnotation.dynamicText = textValue;
      this.receiptPDFViewer.focusAnnotation.notes = textValue;

      this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.modifyDynamicTextValue(
        textValue,
        this.receiptPDFViewer.focusAnnotation.annotationId
      );
      this.VCPdfViewer.VCSyncfusionPdfViewer.annotation.editAnnotation(
        this.receiptPDFViewer.focusAnnotation
      );

      this.saveAnnotatedFile();
    }
    return this.receiptPDFViewer.focusAnnotation;
  }

  receiptNote(cancelToken?: boolean): void {
    if (
      this.securityHandler.canEdit() &&
      !this.workspace.isLoading &&
      !this.workspace.isLoadingPreview
    ) {
      if (!cancelToken) {
        if (this.receiptPDFViewer.annotationAddMode.mode !== 'None') {
          // console.log('receiptNote - create');
          this.createReceiptNote(cancelToken);
        } else if (this.VCreceiptNoteTable.selectedRow !== -1) {
          // console.log('receiptNote - edit');
          this.editReceiptNote(cancelToken);
        }
      } else if (!this.visibilityController.note) {
        this.visibilityController.noteSwitch();
      }
    }
  }

  formatTextAnnotation(Values: any): string {
    return `${Values.rcptNtsRefText ? `Bezug: ${Values.rcptNtsRefText}` : ''}${
      Values.rcptNtsNote
    }`;
  }

  // Input: PDF-Viewer-Annotation
  createReceiptNote(cancelToken?: boolean): void {
    if (this.securityHandler.canEdit()) {
      const TextAnnotation = this.VCNote.getValues();
      const annotation = this.receiptPDFViewer.focusAnnotation;

      if (!cancelToken) {
        if (
          ExcCoreModule.Array.ExistsObject(
            this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
            'annotationId',
            annotation.annotationId
          )
        ) {
          Object.assign(annotation, {
            bodyValue: this.formatTextAnnotation(TextAnnotation),
          });

          this.excRest
            .post(
              this.excRest.computeUrl('ReceiptNoteC', {
                rcptID: this.Data.rcptID,
              }),
              {
                rcptNtsNote: TextAnnotation.rcptNtsNote,
                rcptNtsReferenceText: TextAnnotation.rcptNtsRefText ? '' : '',
                rcptAnno_annotationID: annotation.annotationId,
                rcptAnnoAnnotation: JSON.stringify(annotation),
              },
              {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
            )
            .subscribe((result: any) => {
              this.responseHandler.create(
                result,
                annotation,
                this.VCPdfViewer,
                this.receiptNoteTable
              );

              if (this.receiptPDFViewer.annotationAddMode.mode === 'FreeText') {
                this.VCPdfViewer.viewer.annotation.setAnnotationMode('None');
              }
            });
        }
      }
    }
  }

  // Input: Table-Row
  editReceiptNote(cancelToken?: boolean): void {
    const rcptNote = this.receiptNoteTable.data[this.VCreceiptNoteTable.selectedRow];
    const TextAnnotation = this.VCNote.getValues();

    this.receiptPDFViewer.focusAnnotation = ExcCoreModule.Array.GetObject(
      this.VCPdfViewer.VCSyncfusionPdfViewer.annotationCollection,
      'annotationId',
      rcptNote.rcptAnno_annotationID
    );

    const annotation = this.editFocusAnnotation(TextAnnotation.rcptNtsNote);

    if (!cancelToken) {
      this.workspace.isLoading = true;
      Object.assign(annotation, {
        bodyValue: this.formatTextAnnotation(TextAnnotation),
      });

      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptNoteU', {
            rcptID: this.Data.rcptID,
            annotationID: annotation.annotationId,
          }),
          {
            rcptNtsNote: TextAnnotation.rcptNtsNote,
            rcptAnnoUPT: rcptNote.rcptAnnoUPT,
            rcptAnnoAnnotation: JSON.stringify(annotation),
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.edit(
            result,
            annotation,
            this.VCPdfViewer,
            this.receiptNoteTable
          );
          this.receiptPDFViewer.focusAnnotation = undefined;
          this.workspace.isLoading = false;
          this.VCNote.initialize();
          this.visibilityController.setDefault();
        });
    } else {
      this.VCNote.note = this.VCNote.valuesClone;
      this.VCNote.initialize();
      this.visibilityController.setDefault();
    }
  }

  // Input: Table-Row
  deleteNote(changeByPDFViewer = false): void {
    const note = this.receiptNoteTable.selectedRow;
    const annotation = this.receiptPDFViewer.focusAnnotation;

    if (note && this.securityHandler.canEdit()) {
      this.workspace.isLoading = true;
      this.excRest
        .delete(
          this.excRest.computeUrl('ReceiptNoteD', {
            rcptID: this.Data.rcptID,
            annotationID: note[this.receiptNoteTable.selectKey],
          }),
          {rcptAnnoUPT: note.rcptAnnoUPT},
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          this.responseHandler.delete(
            result,
            annotation,
            this.VCPdfViewer.VCSyncfusionPdfViewer,
            this.receiptNoteTable,
            changeByPDFViewer
          );
          this.VCreceiptNoteTable.selectedRow = -1;
          this.receiptNoteTable.preSelectedIndex = -1;
          this.workspace.isLoading = false;
          this.receiptPDFViewer.focusAnnotation = undefined;
          this.visibilityController.setDefault();
          this.saveAnnotatedFile();
        });
    }
  }

  // </Receipt>

  /**
   * <Receipt State>
   */
  showMessageSureAbout = (tabinstanceCloseable?: boolean): boolean => {
    if (!this.checkChanges) {
      this.checkChanges = true;
      return true;
    }

    if (
      this.VCreceipt && this.VCreceipt?.statementChanged && this.VCreceipt?.statementEditMode
    ) {
      this.modalService
        .showSimple(
          this.getGlobal('Attention') + '!',
          this.getResource('UnsavedChanges'),
          true,
          true,
          this.getGlobal('Save'),
          this.getGlobal('Reject')
        )
        .subscribe((ret: boolean) => {
          this.checkChanges = false;
          this.checkReviewChanges = false;

          if (this.VCreceipt.statementEditMode) {
            this.saveReceipt(!ret);
          }
          if (this.tabinstance && tabinstanceCloseable) {
            this.reloadOpenerView.emit(); // reloadData
            this.tabinstance.Close();
          }
        });

      return false;
    } else {
      this.checkChanges = false;
      if (this.VCreceipt.statementEditMode) {
        this.VCreceipt.statementEditMode = false;
      }
      return true;
    }
  }

  pickReceiptReview = (): void => {
    if (this.securityHandler.canPick()) {
      this.modalService
        .showSimple(
          this.getRessource('Review'),
          this.getRessource('PickRcptText'),
          true,
          true,
          this.getRessource('PickRcptConfirm'),
          this.getRessource('PickRcptReject')
        )
        .subscribe((ret: boolean) => {
          if (ret) {
            this.pickReview();
          }
        });
    }
  }

  pickReview(): void {
    if (this.securityHandler.canPick()) {
      this.excCall_RcptChangeState();
      this.showMessageSomething(
        'Stellungnahmestatus NEU: ' +
        this.enumSvc.getEnumerationText(
          'ReceiptStatus',
          this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus
        ),
        'fal fa-clipboard-list-check',
        'md-toast bg-green'
      );
    }
  }

  excCall_RcptChangeState(): void {
    if (this.securityHandler.powerUser()) {
      this.excRest
        .put(
          this.excRest.computeUrl('ReceiptU_Review', {
            rcptID: this.Data.rcptID,
          }),
          {
            rcptUPT: this.workspace.receiptData.rcptUPT,
            rcptAccepted: null,
            rcptStateChange: true,
            rcptReviewDate: null,
            rcptReviewComment: null,
            rcptReviewReasons: null,
            rcptCommentNext: null,
          },
          {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
        )
        .subscribe((result: any) => {
          if (result) {
            this.showMessageSureAbout(false);

            this.workspace.loadData(result.data.Receipt);
            this.VCreceipt.initialize();
            this.workspace.isLoading = false;
          }
        });
    }
  }

  receiptReviewSave(
    cancelToken = false,
    stateChange?: boolean,
    accepted?: boolean
  ): void {
    if (!cancelToken && this.securityHandler.canEdit()) {

      if (this.workspace.receiptData) {
        const review = this.workspace.receiptData;
        this.excRest
          .put(
            this.excRest.computeUrl('ReceiptU_Review', {
              rcptID: this.Data.rcptID,
            }),
            {
              rcptUPT: this.workspace.receiptData.rcptUPT,
              rcptAccepted: accepted,
              rcptStateChange: stateChange,
              rcptCommentNext: review.rcptCommentNext,
            },
            {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}}
          )
          .subscribe((result: any) => {
            if (result) {
              this.workspace.loadData(result.data.Receipt);
              this.loadCommentaryList();
            }
            this.workspace.isLoading = false;
          });
      }
    } else {
      this.workspace.isLoading = false;
    }
  }

  receiptReview(
    btnText: string,
    stateChange?: boolean,
    accepted?: boolean
  ): void {
    this.modalService
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus <= 2
              ? 'beforeProof'
              : accepted !== undefined
                ? 'beforeFinish'
                : 'beforeToSv'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.workspace.receiptData,
        forceComment:
          this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus === 4 &&
          stateChange &&
          accepted === undefined,
      })
      .subscribe((ret: boolean) => {
        if (ret) {
          this.receiptReviewSave(false, stateChange, accepted);
          if (stateChange) {
            this.showMessageSomething(
              'Stellungnahmestatus NEU: ' +
              this.enumSvc.getEnumerationText(
                'ReceiptStatus',
                this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus
              ),
              'fal fa-clipboard-list-check',
              'md-toast bg-green'
            );
            if (accepted !== undefined) {
              if (accepted) {
                this.showMessageSomething(
                  'Stellungnahme freigegeben',
                  'fal fa-clipboard-list-check',
                  'md-toast bg-green'
                );
              } else if (!accepted) {
                this.showMessageSomething(
                  'Stellungnahme stoniert',
                  'fal fa-file-minus',
                  'md-toast bg-red'
                );
              }
            }
            if (this.securityHandler.canPick()) {
              this.pickReceiptReview();
            }
            this.workspace.isLoading = false;
          } else {
            this.showMessageSomething(
              'Bearbeitung gespeichert',
              'fal fa-clipboard-list',
              'md-toast'
            );
          }
          this.workspace.isLoading = false;
        } else {
          this.showMessageSomething(
            'Bearbeitung fortgesetzt',
            'fal fa-clipboard-list',
            'md-toast'
          );
          this.workspace.isLoading = false;
        }
      });
  }

  receiptReviewU_RevokeState(btnText: string): void {
    this.modalService
      .show('ReceiptCommentNextComponent', {
        modalHeader: this.getRessource('review.changeStateTitle', {btnText}),
        changeStateText: this.getRessource(
          `review.changeStateText.${
            this.isOneOf(this.workspace.receiptData.rcpt_enmIdent_ReceiptStatus, [10, 20]) ?
              'revokeFinal' : 'revokeFinal'
          }`,
          {btnText}
        ),
        btnText,
        reviewClone: this.workspace.receiptData,
        forceComment: true,
      })
      .subscribe((ret: boolean) => {
        if (ret) {
          const review = this.workspace.receiptData;
          this.excRest
            .put(this.excRest.computeUrl('ReceiptU_RevokeState', {
              rcptID: this.Data.rcptID,
            }), {
              rcptUPT: this.workspace.receiptData.rcptUPT
              , rcptCommentNext: review.rcptCommentNext,
            }, {MetaInfo: {dataPaging: {pageNo: 0, pageSize: 0}}})
            .subscribe((result: any) => {
              if (result) {
                this.workspace.loadData(result.data.Receipt);
                this.loadCommentaryList();
              }
              this.workspace.isLoading = false;
            });
        }
      });
  }

  // </Receipt State>

  receiptOpenMessageModal = (): void => {
    if (this.securityHandler.canView()) {
      this.modalService
        .show('CommentaryModalComponent', {
          checkview: this,
        })
        .subscribe(() => {
          this.loadCommentaryList();
        });
    }
  }

  loadCommentaryList = (): void => {
    if (this.securityHandler.canView()) {
      this.excRest
        .get(
          this.excRest.computeUrl('ReceiptCommentary', {
            rcptID: this.Data.rcptID,
          }),
          {}
        )
        .subscribe((response: any) => {
          if (response && response.success) {
            this.workspace.loadCommentaries(
              response.data.Commentary,
              response.data.CommentaryDate
            );
          }
        });
    }
  }

  commentaryCreate = (obj: { commText: string; commTyp: number }): void => {
    if (this.securityHandler.canView()) {
      this.excRest
        .post(
          this.excRest.computeUrl('ReceiptCommentary', {
            rcptID: this.Data.rcptID,
          }),
          obj
        )
        .subscribe((response: any) => {
          if (response && response.sucess) {
            this.workspace.loadCommentaries(
              response.data.Commentary,
              response.data.CommentaryDate
            );
            this.loadCommentaryList();
          }
        });
    }
  }

  // </     >
  openWorkspace(): void {
    if (this.workspace.details.taskDetails?.vorgID) {
      this.appSvc.Task.Workspace.OpenTabV2(
        this.workspace.details.taskDetails?.vorgID
      );
    }
  }

  showMessageSomething(
    msg: string,
    icon: string,
    additionalClasses?: string | ''
  ): void {
    this.modalService.showToast(msg, `md-toast ${additionalClasses}`, icon);
  }

  finish(before?: boolean): void {
    if (this.showMessageSureAbout()) {
      this.reloadOpenerView.emit(); // reloadData
      if (!before) {
        this.tabinstance.Close();
      }
    }
  }

  receiptShowPreviewModal(): void {
    if (!this.workspace.isLoadingPreview) {
      this.modalService.show('ModalPdfViewerComponent', {rcptID: this.Data.rcptID, endpoint: 'ReceiptR_Statement_review'})
        .subscribe(() => {
        });
    }
  }

  get getCommentaryLength(): number {
    return this.workspace.commentary.filter((entry: any) => entry.commType === 1).length;
  }

  isOneOf(x: number, values: number[]): boolean {
    return values.includes(x);
  }

  OpenFileReplaceModal(): void {
    if (!this.workspace.isLoading
      && !this.workspace.isLoadingPreview
      && this.securityHandler.canEdit()
    ) {
      this.appSvc.Receipt.Upload.OpenModalCU_File(
        this.Data.rcptID,
        {
          onlyNotes: true,
          rcpt_fileStreamID: this.workspace.receiptData.rcpt_fileStreamID,
          vorgID: this.workspace.details.taskDetails?.vorgID
        },
        {Events: this.Events}
      );
    }
  }

  OpenFileAddModal(): void {
    if (!this.workspace.isLoading
      && !this.workspace.isLoadingPreview
      && this.securityHandler.canEdit()
    ) {
      this.appSvc.Receipt.Upload.OpenModalU_AddFile(
        this.Data.rcptID,
        {
          onlyNotes: true,
          rcpt_fileStreamID: this.workspace.receiptData.rcpt_fileStreamID,
          vorgID: this.workspace.details.taskDetails?.vorgID
        },
        {Events: this.Events}
      );
    }
  }
}
